/**
 * Created by z179603 on 1/31/17.
 */
'use strict';

angular.module('cvsApp').service('redirectService', ['$log', '$location', 'getCampaignInfoService','processDispositionService', 'PageValues', function ($log, location, GCIS, processDispositionService , PageValues) {



    this.getRedirectUrl = function (mode, errorInd) {
        var url;
        var xid = cvsUtility.queryMap.xid || PageValues.xid;
        var cmp = cvsUtility.queryMap.cmp || PageValues.cmp;
        var isOncologyChampaign = cvsUtility.queryMap.cmp && cvsUtility.queryMap.cmp == "ccc";
        var isHEEchampaign = cvsUtility.queryMap.cmp && cvsUtility.queryMap.cmp == "hee";
        var source = cvsUtility.queryMap.source;
        var accessKey = cvsUtility.queryMap.accessKey;
        if (PageValues.appConfig && PageValues.appConfig.validateResponse) {
            var memberOnlineStatus = PageValues.appConfig.validateResponse.memberOnlineStatus;
            var messageID = PageValues.appConfig.validateResponse.secureData && PageValues.appConfig.validateResponse.secureData.message_id ? PageValues.appConfig.validateResponse.secureData.message_id : "";
            var campaignName = PageValues.appConfig.validateResponse.secureData && PageValues.appConfig.validateResponse.secureData.campaign_name ? PageValues.appConfig.validateResponse.secureData.campaign_name : "";
            var campaign_id = PageValues.appConfig.validateResponse.secureData && PageValues.appConfig.validateResponse.secureData.campaign_id ? PageValues.appConfig.validateResponse.secureData.campaign_id : "";
            var contextInformation = PageValues.appConfig.validateResponse.contextInformation ? PageValues.appConfig.validateResponse.contextInformation : "XID";
            var partialToken = PageValues.appConfig.validateResponse.partialToken;
        }

        var getFastProxyUrl = function (url) {
            return url.replace('wps/', 'FASTPROXY/');
        }

        // Oncology CAT-15920
        if (isOncologyChampaign) {
            if (errorInd) {
                url = getFastProxyUrl(PageValues.appConfig.portalUrl) + PageValues.wcm.navigationUrl.classic_login + "oncology&deepLink=expired";
                window.top.location = encodeURI(url);
            } else  {
                GCIS.getCampaignInfo(function (data) {  
                    if (data.SERVER_ERROR) {
                        location.path("/error");
                        return;
                    } else if (data.getError() === '' && data.getHeader().statusCode === '0000' && data.getDetails().messageID) {
                            var oncRedirectToComp = (PageValues.appConfig.validateResponse && PageValues.appConfig.validateResponse.secureData.campaign_name) || 'oncology';
                            if (memberOnlineStatus && memberOnlineStatus == "InActive") {
                                url = getFastProxyUrl(PageValues.appConfig.portalUrl) + PageValues.wcm.navigationUrl.fastproxy_qr_unregistered + oncRedirectToComp.toLowerCase() + "&referral=oncology" + "&partialLoginToken=" + partialToken + "&memberOnlineStatus="
                                + memberOnlineStatus + "&contextInformation="
                                + contextInformation; 
                                url = url + (xid ? "&xid=" + xid : "");
                                url = url + (messageID ? "&messageID=" + messageID : "");
                            } else {
                                url = getFastProxyUrl(PageValues.appConfig.portalUrl) + PageValues.wcm.navigationUrl.classic_login + oncRedirectToComp.toLowerCase() + "&referral=oncology";
                                url = url + (xid ? "&xid=" + xid : "");
                                url = url + (messageID ? "&messageID=" + messageID : "");
                            }
                            if (PageValues.appConfig.validateResponse && PageValues.appConfig.validateResponse.memberInfoEnc) {
                                url = url + (PageValues.appConfig.validateResponse.memberInfoEnc.sourceSystemKeyValueHash ? "&sourceSystemKeyValueHash=" + PageValues.appConfig.validateResponse.memberInfoEnc.sourceSystemKeyValueHash : undefined);
                                url = url + (PageValues.appConfig.validateResponse.memberInfoEnc.sourceSystemName ? "&sourceSystemName=" + PageValues.appConfig.validateResponse.memberInfoEnc.sourceSystemName : undefined);
                                url = url + (PageValues.appConfig.validateResponse.memberInfoEnc.sourceSystemKeyValueEnc ? "&sourceSystemKeyValueEnc=" + PageValues.appConfig.validateResponse.memberInfoEnc.sourceSystemKeyValueEnc : undefined);
                            }
                    } else {
                        url = getFastProxyUrl(PageValues.appConfig.portalUrl) + PageValues.wcm.navigationUrl.classic_login + "oncology&deepLink=expired";
                    }
                    window.top.location = encodeURI(url);
                }, messageID);
            }
        
        }else if (isHEEchampaign) {
            processDispositionService.processDisposition(function (data) {  
                if(PageValues.appConfig.validateResponse.redirect_url) {
                    window.location = PageValues.appConfig.validateResponse.redirect_url;
                }
            }, messageID);
        }else { // this block will execute for all champaign other than /ccc (Oncology)
            GCIS.getCampaignInfo(function (data) { //Event service call for non Oncology
            if(PageValues.appConfig.validateResponse && PageValues.appConfig.validateResponse.redirect_url) {
                url = PageValues.appConfig.validateResponse.redirect_url;
            } else {
                if (mode === "app") {
                    url = PageValues.wcm.securechat.tapStreamUrl + "?";
                    url = url + (xid ? "xid=" + xid : "");
                } else if (memberOnlineStatus && memberOnlineStatus == "InActive") {
                    url = PageValues.appConfig.portalUrl + PageValues.wcm.navigationUrl.qr_unregistered + "securechat&" + "partialLoginToken=" + partialToken + "&memberOnlineStatus="
                        + memberOnlineStatus + "&contextInformation="
                        + contextInformation + "&";
                    url = url + (source ? "source=" + source + "&" : "");
                    url = url + (accessKey ? "accessKey=" + accessKey : "");
                    url = url + (xid ? "xid=" + xid : "");
                    url = url + (messageID ? "&messageID=" + messageID : "");
                    url = url + (campaignName ? "&campaignName=" + campaignName : "");
                    url = url + (campaign_id ? "&campaign_id=" + campaign_id : "");
                    if (PageValues.appConfig.validateResponse && PageValues.appConfig.validateResponse.contextInformation && PageValues.appConfig.validateResponse.contextInformation == "TAP" && PageValues.appConfig.validateResponse.trackingInformation) {
                        url = url + (PageValues.appConfig.validateResponse.trackingInformation.carrierName ? "&carrierName=" + PageValues.appConfig.validateResponse.trackingInformation.carrierName : undefined);
                        url = url + (PageValues.appConfig.validateResponse.carrierNumber ? "&carrierNumber=" + PageValues.appConfig.validateResponse.trackingInformation.carrierNumber : undefined);
                        url = url + (PageValues.appConfig.validateResponse.carrierUrl ? "&carrierUrl=" + PageValues.appConfig.validateResponse.trackingInformation.carrierUrl : undefined);
                    }
                    if (PageValues.appConfig.validateResponse && PageValues.appConfig.validateResponse.memberInfoEnc) {
                        url = url + (PageValues.appConfig.validateResponse.memberInfoEnc.sourceSystemKeyValueHash ? "&sourceSystemKeyValueHash=" + PageValues.appConfig.validateResponse.memberInfoEnc.sourceSystemKeyValueHash : undefined);
                        url = url + (PageValues.appConfig.validateResponse.memberInfoEnc.sourceSystemName ? "&sourceSystemName=" + PageValues.appConfig.validateResponse.memberInfoEnc.sourceSystemName : undefined);
                        url = url + (PageValues.appConfig.validateResponse.memberInfoEnc.sourceSystemKeyValueEnc ? "&sourceSystemKeyValueEnc=" + PageValues.appConfig.validateResponse.memberInfoEnc.sourceSystemKeyValueEnc : undefined);
                    }
                } else {
                    var redirectToComp = "securechat";
                    if (campaignName) {
                        redirectToComp = PageValues.appConfig.validateResponse.secureData.campaign_name;
                    } else if (contextInformation) {
                        redirectToComp = PageValues.appConfig.validateResponse.contextInformation == "OP" ? "qr_op" : "qr_rfr";
                    }
                    if (errorInd) {
                        url = PageValues.appConfig.portalUrl + PageValues.wcm.navigationUrl.qr_registered + redirectToComp.toLowerCase() +
                            "&deepLink=expired";
                    } else {
                        redirectToComp = redirectToComp.toLowerCase();
                        var portalUrl = PageValues.appConfig.portalUrl + PageValues.wcm.navigationUrl.qr_registered;
                        var messageIdParam = "&messageID=" + messageID;
                        var queryParams = "&xid=" + xid;
                        var additionalParams = messageIdParam + queryParams;
                        PageValues && PageValues.redirectToComponent && PageValues.redirectToComponent.forEach(function(component) {
                            if(component && component.campaign === cmp) {
                                if(component.digitalFastProxy) {
                                    portalUrl = PageValues.appConfig.ngxPortalUrl + PageValues.wcm.navigationUrl.digital_fastproxy_registered;
                                }
                                
                                additionalParams = component.skipMessageId ? queryParams : additionalParams;                                
                                redirectToComp = component.navigationUrl ? component.navigationUrl + redirectToComp : redirectToComp;
                            }
                        });
                        url = portalUrl + redirectToComp + additionalParams;
                    }
    
                    if (PageValues.appConfig.validateResponse && PageValues.appConfig.validateResponse.memberInfoEnc && (campaignName.toLowerCase() != "securechat")) {
                        url = url + (PageValues.appConfig.validateResponse.memberInfoEnc.sourceSystemKeyValueHash ? "&sourceSystemKeyValueHash=" + PageValues.appConfig.validateResponse.memberInfoEnc.sourceSystemKeyValueHash : undefined);
                        url = url + (PageValues.appConfig.validateResponse.memberInfoEnc.sourceSystemName ? "&sourceSystemName=" + PageValues.appConfig.validateResponse.memberInfoEnc.sourceSystemName : undefined);
                        url = url + (PageValues.appConfig.validateResponse.memberInfoEnc.sourceSystemKeyValueEnc ? "&sourceSystemKeyValueEnc=" + PageValues.appConfig.validateResponse.memberInfoEnc.sourceSystemKeyValueEnc : undefined);
                    } 
                }
            }
            window.top.location = encodeURI(url);
          }, messageID);
        }
        // url = encodeURI(url);
        // return url;
     };

   this.callCampaignInfoSERVICE = function(messageID) {
    GCIS.getCampaignInfo(function (data) { }, messageID);
   } 

    this.validateXIDRequestBody = function () {
        var headerRequest = {
            securityContext: {
                apiKey: PageValues.appConfig.apiKey
            },
            serviceContext: {
                appName: "SPL_Web",
                lineOfBusiness: "Specialty",
                serviceCors: "True",
                channelName: "Web"
            }
        };
        var requestJson = {
            validateLinkRequest: {
                header: headerRequest
            }
        };
        if (cvsUtility.queryMap.xid || PageValues.xid) {
            requestJson.validateLinkRequest.details = {
                xid: cvsUtility.queryMap.xid || PageValues.xid,
                mode: cvsUtility.queryMap.route && cvsUtility.queryMap.route == "app" ? "lite" : PageValues.routeParam && PageValues.routeParam == "app" ? "lite" : "full",
            };
        } else if (cvsUtility.queryMap.accessKey) {
            requestJson.validateLinkRequest.details = {
                "entryKey": cvsUtility.queryMap.accessKey
            };
        }
        return requestJson;
    }
}]);
